import { useTranslation } from "react-i18next";

import { createOrganicCellRenderers } from "../components/organicCellRenderers";
import { createOrganicRowClickHandler } from "../utils/organicRowClick";

import { useDrawer } from "@/components/ui/v2/use-drawer";
import type { CellRenderersHook } from "@/features/integrations/shared/renderer/hooks/types";
import useToast from "@/lib/hooks/useToast";

/**
 * Hook that provides custom cell renderers for the organic vacancy table.
 * Defined at module level so the function reference is stable across renders.
 */
export const useOrganicCellRenderers: CellRenderersHook = (params) => {
  const { openDrawer } = useDrawer();
  const { t } = useTranslation();
  const { showToast } = useToast();

  if (!params.clientId) return undefined;

  // TODO: make this bottom part generic, for now its fine because we do this only in werkzoeken and jobadpartner
  const onTitleClick = createOrganicRowClickHandler(params.clientId, openDrawer, {
    drawerTitle: t("vacancies.drawer.title", { defaultValue: "Vacancy details" }),
    onError: () => showToast(t("common.error", { defaultValue: "Something went wrong" }), "error"),
  });
  return createOrganicCellRenderers(onTitleClick);
};
